export const spacesUrl = (
  id: string,
  accessToken: string,
  vanityDomainSpaces?: string,
  subdomain?: string,
  buildMode?: 'theme' | 'sidebar' | 'blueprint' | 'assistant' | 'none'
) => {
  const URL = spacesBaseUrl(accessToken, vanityDomainSpaces, subdomain)

  if (!URL) return ''

  // Create the base URL without hash
  const baseUrl = `${URL}/space/${id}`

  // Create URLSearchParams for hash parameters
  const hashParams = new URLSearchParams({
    r: window.location.origin,
    t: accessToken,
  })

  // Add optional parameters
  if (buildMode && buildMode !== 'none') {
    hashParams.append('buildPage', buildMode)
  }

  // Combine base URL with hash parameters
  return `${baseUrl}#${hashParams.toString()}`
}

export const spacesBaseUrl = (accessToken: string, vanityDomainSpaces?: string, subdomain?: string) => {
  const BASE_SPACES_URL = vanityDomainSpaces ?? window.flatfile.configService.get('VITE_SPACES_URL')

  const TRIMMED_BASE_SPACES_URL = BASE_SPACES_URL?.replace(/\/$/, '')

  const URL =
    subdomain && !vanityDomainSpaces
      ? TRIMMED_BASE_SPACES_URL.replace('//', `//${subdomain}.`)
      : TRIMMED_BASE_SPACES_URL

  return URL
}
